import { useFindRecord } from 'api/APIHooks';

const usePayerWQInteractiveView = (payerId) => {
  const {
    isLoading, data, isError, error,
  } = useFindRecord(
    'payer',
    payerId,
    {
      queryConfig: {
        enabled: !!payerId,
        placeholderData: undefined,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        retry: 2,
      },
    },
  );

  const payerWQInteractiveView = data?.data?.data?.payer_wq_interactive;

  if (isError && error) {
    // eslint-disable-next-line no-console
    console.error('Failed to fetch payer WQ interactive view:', error);
  }

  return {
    isLoading,
    payerWQInteractiveView,
    isError,
    error,
  };
};

export default usePayerWQInteractiveView;
